import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAuthenticated } from 'store/user/userSelectors';
import { clearMemberFavourites, fetchMemberFavourites } from 'store/memberFavourites/memberFavouritesActions';

const MemberFavouritesFetcher = () => {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(getIsAuthenticated);

  useEffect(() => {
    isAuthenticated ? dispatch(fetchMemberFavourites()) : dispatch(clearMemberFavourites());
  }, [dispatch, isAuthenticated]);

  return null;
};

export default MemberFavouritesFetcher;
